import { FormProviderProps } from 'antd/es/form/context';
import { useContext, type JSX } from 'react';
import { GLOB } from 'src/util/Glob';
import useSelectModal from '../hook/useSelectModal';
import { RuleContext } from '../XmRule';
import TagsList, { TagItem } from './TagsList';

export interface CustomFormCompProps<Value> {
  value?: Value;
  onChange?: (value: Value) => void;
}

interface ItemsProps<T> extends CustomFormCompProps<T[]> {
  modalProps: Parameters<ReturnType<typeof useSelectModal<T[]>>[0]>[0];
  makeTreeObj: (item: T) => TagItem;
  renderAddButton: (handleAdd: () => void) => JSX.Element;
  isLoading?: boolean;
  filterByParentsOnModalFormFinish?: boolean;
}

const Items = <T extends { item_id: string; }>({
  value,
  onChange,
  makeTreeObj,
  filterByParentsOnModalFormFinish = false,
  modalProps,
  isLoading = false,
  renderAddButton
}: ItemsProps<T>) => {
  const { filterByParents } = useContext(RuleContext);

  const handleFormFinish: FormProviderProps['onFormFinish'] = (_, { forms }) => {
    const { items }: Object & { items: T[]; } = forms['selected-items'].getFieldsValue(true);
    onChange?.(items);
    if (filterByParentsOnModalFormFinish)
      filterByParents();
  };

  const [showModalSelect, contextHolder] = useSelectModal<T[]>({
    onFormFinish: handleFormFinish,
  });

  const handleAdd = () => {
    showModalSelect(modalProps);
  };

  const handleCloseItem = (id: string) => () => {
    onChange?.(value?.filter(item => item.item_id !== id));
    if (filterByParentsOnModalFormFinish)
      filterByParents();
  };

  return <>
    <div className={isLoading ? 'xm-items-loading' : 'xm-items-loaded'}>
      {!isLoading &&
        <TagsList
          items={value?.map(makeTreeObj).sort((a, b) => GLOB.naturalSort(a.title, b.title))}
          onClose={handleCloseItem}
        />
      }
    </div>
    {contextHolder}
    {renderAddButton(handleAdd)}
  </>;
};

export default Items;